import React, { useState, useEffect, useRef } from 'react';
import { Plus, FileSpreadsheet, Trash2, Save, LayoutDashboard, ChevronRight, Building, Printer, ClipboardPaste, ArrowRight, RotateCcw, Settings, Download, UploadCloud, FileJson, Upload, FolderPlus, Layers, X, Pencil, Cloud, CloudOff, LogOut, Lock, FileText } from 'lucide-react';
import TranscriptPanel from './TranscriptPanel';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, doc, setDoc, onSnapshot } from 'firebase/firestore';

// --- RSC CMOD BUILDER v1.8 (VERCEL RELEASE - SMART SYNC) ---

// --- FIREBASE CONFIGURATION ---
const firebaseConfig = {
  apiKey: "AIzaSyA3zOBeJmLrzCFJtB14hzHoRYB4imTpOVE",
  authDomain: "rsc-cmod-builder.firebaseapp.com",
  projectId: "rsc-cmod-builder",
  storageBucket: "rsc-cmod-builder.firebasestorage.app",
  messagingSenderId: "57539971745",
  appId: "1:57539971745:web:a275a2726f6ba11f383ee0"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const appId = 'rsc-cmod-builder';

// --- INITIAL DATA (HARDCODED FALLBACK) ---
const hardcodedProjects = {
  "autumn-park": {
    "id": "autumn-park",
    "name": "Autumn Park Renovation",
    "mods": [
      { "id": 1, "modNumber": "1", "date": "2025-08-11", "project": "Autumn Park Renovation", "subcontractor": "RainTech Quote", "description": "Change to GAF Timberline Natural Shadow 40-year shingle warranty and 25-year workmanship warranty", "amount": 9304, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 2, "modNumber": "2", "date": "2025-08-11", "project": "Autumn Park Renovation", "subcontractor": "Temco Quote", "description": "Replace bathroom light fixtures with 11\" round & swap kitchen fixtures for 4-ft", "amount": 2248.08, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 3, "modNumber": "3", "date": "2025-08-21", "project": "Autumn Park Renovation", "subcontractor": "Grandview Quote", "description": "Material to change corner blind cabinet in each unit & handicap unit to a corner base, easy-reach cabinet.", "amount": 3751.38, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 4, "modNumber": "4", "date": "2025-09-03", "project": "Autumn Park Renovation", "subcontractor": "All Set Flooring", "description": "LVT and VCT changes", "amount": 25098.68, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 5, "modNumber": "5", "date": "2025-09-02", "project": "Autumn Park Renovation", "subcontractor": "Whaling Construction", "description": "Excavation & Base Installation Work At The Pergola & Saferoom Areas Per Testing Lab Recommendations.", "amount": 29779.64, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 6, "modNumber": "6", "date": "2025-10-30", "project": "Autumn Park Renovation", "subcontractor": "RSC Labor", "description": "Finish Millwork To Encapsulate The Louvers", "amount": 2265.12, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 7, "modNumber": "7", "date": "2025-10-31", "project": "Autumn Park Renovation", "subcontractor": "PlumbCo", "description": "Install A Cover On Exposed Copper", "amount": 2332, "status": "Rejected", "category": "Contractor Contingency", "notes": "REJECTED" },
      { "id": 8, "modNumber": "8", "date": "2025-11-11", "project": "Autumn Park Renovation", "subcontractor": "Temco Quote", "description": "Provide and install (72) lay-in drop lenses per Addendum #4", "amount": 3139.72, "status": "Rejected", "category": "Contractor Contingency", "notes": "REJECTED" },
      { "id": 9, "modNumber": "9", "date": "2025-11-12", "project": "Autumn Park Renovation", "subcontractor": "Rick Scott Construction", "description": "Insulate Existing Domestic Water Lines", "amount": 1552.57, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 10, "modNumber": "10", "date": "2025-11-13", "project": "Autumn Park Renovation", "subcontractor": "PlumbCo", "description": "Offset For The (4) ADA Restrooms", "amount": 1590, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 11, "modNumber": "11", "date": "2025-11-14", "project": "Autumn Park Renovation", "subcontractor": "PlumbCo", "description": "Sewer Line Alteration", "amount": 8598.72, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "" },
      { "id": 12, "modNumber": "12", "date": "2025-11-20", "project": "Autumn Park Renovation", "subcontractor": "PlumbCo", "description": "Ada Protective Covers For Plumbing Assemblies", "amount": 1157.52, "status": "Sent to Owner", "category": "Contractor Contingency", "notes": "" },
      { "id": 13, "modNumber": "13", "date": "2025-11-20", "project": "Autumn Park Renovation", "subcontractor": "Hahn Appliance", "description": "ADA Microwave Revision", "amount": 997.5, "status": "Sent to Owner", "category": "Contractor Contingency", "notes": "" },
      { "id": 14, "modNumber": "14", "date": "2025-11-25", "project": "Autumn Park Renovation", "subcontractor": "Whaling Construction", "description": "Concrete In The Fire Lane", "amount": 3498, "status": "Sent to Architect", "category": "Contractor Contingency", "notes": "" },
      { "id": 15, "modNumber": "15", "date": "2026-01-06", "project": "Autumn Park Renovation", "subcontractor": "Whaling Construction", "description": "Fireline Curbs & Bollards", "amount": 4850.56, "status": "Sent to Architect", "category": "Contractor Contingency", "notes": "Extension of fire lane on opposite side of shelter." },
      { "id": 16, "modNumber": "16", "date": "2026-01-06", "project": "Autumn Park Renovation", "subcontractor": "Plumb.Co", "description": "Elevator 2in Sump Pump Float Switch", "amount": 2544, "status": "Sent to Architect", "category": "Contractor Contingency", "notes": "" },
      { "id": 17, "modNumber": "17", "date": "2026-01-06", "project": "Autumn Park Renovation", "subcontractor": "Plumb.Co", "description": "New Angle Stops And Escutcheons", "amount": 2924.54, "status": "Drafted", "category": "Contractor Contingency", "notes": "" },
      { "id": 18, "modNumber": "18", "date": "2026-01-10", "project": "Autumn Park Renovation", "subcontractor": "A-Wing & B-Wing", "description": "Ceiling Grid – A & B Wings (per RFI #6)", "amount": 14145.7, "status": "Drafted", "category": "Contractor Contingency", "notes": "" }
    ],
    "settings": {
      "originalContingency": 388950,
      "ownerName": "Life Senior Services",
      "ownerAddress1": "5950 E 31st St",
      "ownerAddress2": "Tulsa, OK 74135",
      "architectName": "Blackledge Architects",
      "architectAddress1": "7416 N. Broadway Ext., Suite L",
      "architectAddress2": "Oklahoma City, OK 73116",
      "contractorName": "Rick Scott Construction, Inc.",
      "contractorAddress1": "4303 N. Pleasant View RD.",
      "contractorAddress2": "Ponca City, OK 74601"
    }
  },
  "osage-casino-project": {
    "id": "osage-casino-project",
    "name": "Osage Casino Project",
    "mods": [
      { "id": 101, "modNumber": "1", "date": "2025-09-08", "project": "Osage Casino Project", "subcontractor": "SWG", "description": "Reroute 4 PVC water line per RFI #11", "amount": 2283.99, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "Provide labor and material to reroute 4\" PVC water line, per RFI #11" },
      { "id": 102, "modNumber": "2", "date": "2025-09-17", "project": "Osage Casino Project", "subcontractor": "Red Rock Utility", "description": "Water Line Separation Outlined In RFI #22 using Option B", "amount": 14750, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "Red Rock Utility has provided a proposal to perform the water line separation outlined in RFI #22 using Option B: lower existing water line, add 45-degree bends, remove and replace existing pavement, and provide a 2' vertical separation (storm line vs. waterline) as required by ODEQ." },
      { "id": 1768339659164, "modNumber": "3", "date": "2026-01-13", "project": "Osage Casino Project", "subcontractor": "SWG", "description": "Install perimeter drain around new addition slab", "amount": 7790.58, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "SWG Plumbing has provided pricing to provide labor and material for the exterior drain around the new addition slab." },
      { "id": 1768339731422, "modNumber": "4", "date": "2025-11-19", "project": "Osage Casino Project", "subcontractor": "SWG", "description": "Relocate Three Existing Underground Data Vaults", "amount": 5001.08, "status": "Fully Executed", "category": "Contractor Contingency", "notes": "RFI #30 Provide all labor, material, equipment, and associated work required to relocate the three existing underground data boxes and related conduits to clear the new curb alignment. Scope includes excavation, hand trenching, PVC conduit, fittings, pull string, backfill, gravel bag stabilization, and installation of new 12x12 Quazite boxes per SWG's extension and pricing." },
      { "id": 1768398728359, "modNumber": "5", "date": "2026-01-14", "project": "Osage Casino Project", "subcontractor": "SWG", "description": "Electrical Panel Feeder Upsizing per Revised Drawings (Rev. 5)", "amount": 33660.3, "status": "Sent to Owner", "category": "Contractor Contingency", "notes": "Revised Drawings Rev. 5 included updates to the electrical distribution and panel loading for panels XSLCE and XSLCE1. Based on these revisions and coordination during submittal review, feeder conductor and conduit sizes were increased to accommodate the revised electrical loads. This change reflects compliance with the updated design requirements shown in Revision 5." },
      { "id": 1768569747023, "modNumber": "6", "date": "2026-01-16", "project": "Osage Casino Project", "subcontractor": "Midwest Drywall", "description": "Change ceiling tile to Luxe Blue", "amount": 8728.04, "status": "Sent to Owner", "category": "Contractor Contingency", "notes": "Per RFI #44 - The VE Option for CL-004 that was accepted was priced using Cirrus 589 black tile and black Suprafine 9/16\" grid. This change shows the additional cost changing from this to Calla 2824 tile and Suprafine 9/16\" grid in custom color SW 6537 Luxe Blue. For CL-008, the change from the VE Option Cirrus 589 black and black Suprafine 9/16\" grid to Cirrus 589 white and white Suprafine 9/16\" (per RFI #44) gives credit on the tile which is applied to this change." }
    ],
    "settings": {
      "originalContingency": 427740.13,
      "ownerName": "Osage Casino",
      "ownerAddress1": "64464 US Highway 60",
      "ownerAddress2": "Ponca City, OK 74604",
      "architectName": "Marnell Architecture",
      "architectAddress1": "222 Via Marnell Way",
      "architectAddress2": "Las Vegas, NV 89119",
      "contractorName": "Rick Scott Construction, Inc.",
      "contractorAddress1": "4303 N. Pleasant View RD.",
      "contractorAddress2": "Ponca City, OK 74601"
    }
  }
};

// --- HELPER FUNCTIONS (GLOBAL SCOPE) ---
const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(amount));
};

// --- SMART MERGE FUNCTION ---
// This function intelligently merges projects from two sources, preserving all unique mods
const mergeProjects = (existingProjects, incomingProjects) => {
  const merged = { ...existingProjects };

  Object.keys(incomingProjects).forEach(projectId => {
    const incomingProject = incomingProjects[projectId];

    if (!merged[projectId]) {
      // New project - add it entirely
      merged[projectId] = incomingProject;
    } else {
      // Existing project - merge mods intelligently
      const existingMods = merged[projectId].mods || [];
      const incomingMods = incomingProject.mods || [];

      // Create a map of existing mods by ID
      const modMap = new Map();
      existingMods.forEach(mod => modMap.set(mod.id, mod));

      // Add/update mods from incoming data
      incomingMods.forEach(incomingMod => {
        const existingMod = modMap.get(incomingMod.id);
        if (!existingMod) {
          // New mod - add it
          modMap.set(incomingMod.id, incomingMod);
        } else {
          // Existing mod - keep the one with more complete data or later status
          // Priority: Fully Executed > Sent to Owner > Sent to Architect > Drafted > Rejected
          const statusPriority = {
            'Fully Executed': 5,
            'Sent to Owner': 4,
            'Sent to Architect': 3,
            'Drafted': 2,
            'Rejected': 1
          };
          const existingPriority = statusPriority[existingMod.status] || 0;
          const incomingPriority = statusPriority[incomingMod.status] || 0;

          // Use incoming if it has higher status priority, or if notes are longer (more detail)
          if (incomingPriority > existingPriority ||
              (incomingPriority === existingPriority &&
               (incomingMod.notes || '').length > (existingMod.notes || '').length)) {
            modMap.set(incomingMod.id, incomingMod);
          }
        }
      });

      // Convert map back to array and sort by modNumber
      const mergedMods = Array.from(modMap.values()).sort((a, b) => {
        const numA = parseInt(a.modNumber) || 0;
        const numB = parseInt(b.modNumber) || 0;
        return numA - numB;
      });

      merged[projectId] = {
        ...merged[projectId],
        ...incomingProject,
        mods: mergedMods,
        // Merge settings, preferring incoming if they have more data
        settings: {
          ...merged[projectId].settings,
          ...incomingProject.settings
        }
      };
    }
  });

  return merged;
};

const calculateFinancials = (mods, originalContingency, currentModId) => {
    let previousUsage = 0;
    const currentModIndex = mods.findIndex(m => m.id === currentModId);
    
    if (currentModIndex === -1) return { previousUsage: 0, currentBalance: originalContingency };

    for (let i = 0; i < currentModIndex; i++) {
      if (mods[i].status !== 'Rejected') {
        previousUsage += Number(mods[i].amount) || 0;
      }
    }
    const currentBalance = originalContingency - previousUsage;
    return { previousUsage, currentBalance };
};

// --- COMPONENT: Document Preview (Single Mod) ---
const DocumentPreview = ({ mod, settings, logoUrl, previousUsage, currentBalance, newBalance }) => {
  if (!mod) return null;

  // Truncate notes to fit on one page - max ~400 characters
  const truncatedNotes = String(mod.notes || mod.description).length > 400
    ? String(mod.notes || mod.description).substring(0, 397) + '...'
    : String(mod.notes || mod.description);

  return (
    <div className="bg-gray-200 p-8 min-h-screen flex justify-center print:bg-white print:p-0">
      <div
          className="bg-white shadow-2xl text-xs font-serif relative flex flex-col"
          id="print-area"
          style={{ width: '8.5in', height: '11in', maxHeight: '11in', overflow: 'hidden', padding: '0.5in' }}
      >
        {/* Header Area */}
        <div className="grid grid-cols-2 gap-2 mb-3 border-b-4 border-blue-900 pb-2">
           <div className="flex items-center justify-start h-16 overflow-hidden">
             {logoUrl ? (
               <img src={logoUrl} alt="Company Logo" className="max-h-16 w-auto max-w-[200px] object-contain object-left" />
             ) : (
               <div className="border-2 border-dashed border-slate-300 p-2 rounded text-slate-300 italic text-center w-full flex items-center justify-center">
                  <span className="text-xs">Logo Placeholder</span>
               </div>
             )}
           </div>
           <div className="text-right flex flex-col justify-center h-16">
             <h3 className="text-xl font-bold text-slate-400 uppercase tracking-wide leading-none mb-1">Contingency Mod</h3>
             <div className="flex justify-end items-center gap-2">
                 <span className="text-slate-500 font-bold uppercase text-[9px]">Number:</span>
                 <span className="text-lg font-bold text-blue-900 leading-none">#{mod.modNumber}</span>
             </div>
             <div className="flex justify-end items-center gap-1">
                 <span className="text-slate-500 font-bold uppercase text-[9px]">Date:</span>
                 <span className="text-slate-600 font-medium text-[10px]">{mod.date}</span>
             </div>
           </div>
        </div>

        {/* Addresses */}
        <div className="grid grid-cols-2 gap-4 mb-3">
          <div>
            <p className="font-bold text-slate-400 text-[9px] uppercase mb-0.5 border-b border-slate-200 pb-0.5">Project</p>
            <p className="font-bold text-sm text-slate-900 leading-tight">{mod.project}</p>
          </div>
          <div>
             <p className="font-bold text-slate-400 text-[9px] uppercase mb-0.5 border-b border-slate-200 pb-0.5">To (Owner)</p>
             <div className="text-slate-800 leading-snug text-[10px]">
                 <p className="font-bold">{settings.ownerName}</p>
                 <p>{settings.ownerAddress1}</p>
                 <p>{settings.ownerAddress2}</p>
             </div>
          </div>
        </div>

        {/* Subject Line & Reference */}
        <div className="mb-2 bg-slate-50 border-l-4 border-blue-900 p-2 rounded-r">
          <div className="flex items-start mb-1">
               <span className="font-bold text-blue-900 mr-2 w-8 text-[10px]">RE:</span>
               <span className="font-bold text-[11px] text-slate-900 leading-snug">{mod.description}</span>
          </div>
          {mod.subcontractor && (
            <div className="flex items-start">
                 <span className="font-bold text-blue-900 mr-2 w-8 text-[10px]">REF:</span>
                 <span className="text-[11px] text-slate-700 leading-snug">{mod.subcontractor}</span>
            </div>
          )}
        </div>

        {/* Body Text */}
        <div className="mb-3 space-y-2 text-justify leading-snug text-slate-800 flex-shrink">
          <p className="font-bold text-[10px]">{settings.ownerName} has authorized the use of Contractors Contingency accordingly:</p>
          <div className="whitespace-pre-wrap pl-3 border-l-2 border-slate-200 text-slate-700 text-[9px] leading-snug py-1 bg-slate-50/50 max-h-[1.8in] overflow-hidden">
             {truncatedNotes}
          </div>
          <p className="text-[10px]">
            Pending approval of {settings.ownerName}, Rick Scott Construction will deduct the Contingency in the amount of
            <span className="font-bold text-blue-900 whitespace-nowrap"> ({formatCurrency(mod.amount)}) </span>
            leaving a remaining Contractors Contingency balance of
            <span className="font-bold whitespace-nowrap"> {formatCurrency(newBalance)}</span>.
          </p>
        </div>

        {/* Summary Table */}
        <div className="mb-3">
          <h4 className="font-bold border-b border-black mb-1 pb-0.5 text-[10px] uppercase tracking-wider">Contingency Summary</h4>
          <table className="w-full text-[10px]">
            <tbody>
              <tr className="border-b border-gray-100">
                <td className="py-0.5 text-slate-600">The total original Contractors Contingency Amount</td>
                <td className="py-0.5 text-right font-mono text-slate-900">{formatCurrency(settings.originalContingency)}</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-0.5 text-slate-600">Net Change by previously authorized Usage</td>
                <td className="py-0.5 text-right font-mono text-red-600">({formatCurrency(previousUsage)})</td>
              </tr>
              <tr className="border-b border-gray-100 bg-slate-50 font-semibold">
                <td className="py-0.5 pl-2">The Contractors Contingency Amount PRIOR to this Authorization</td>
                <td className="py-0.5 text-right font-mono pr-2 text-slate-900">{formatCurrency(currentBalance)}</td>
              </tr>
              <tr className="border-b border-gray-100">
                <td className="py-0.5 text-slate-600">This Deduction</td>
                <td className="py-0.5 text-right font-mono text-red-600 font-bold">({formatCurrency(mod.amount)})</td>
              </tr>
              <tr className="bg-blue-50 font-bold border-t-2 border-blue-200">
                <td className="py-1 pl-2 text-blue-900">New Contractors Contingency Amount</td>
                <td className="py-1 text-right font-mono text-sm pr-2 text-blue-900">{formatCurrency(newBalance)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Approvals */}
        <div className="mt-auto pt-2 border-t border-slate-200">
           <h4 className="font-bold uppercase tracking-widest text-[9px] text-slate-400 mb-2">Approvals</h4>
           <div className="grid grid-cols-3 gap-4">
              <div>
                 <p className="font-bold text-[9px] uppercase text-slate-800">{settings.architectName}</p>
                 <p className="text-[8px] text-slate-500 leading-tight">{settings.architectAddress1}</p>
                 <p className="text-[8px] text-slate-500 mb-3 leading-tight">{settings.architectAddress2}</p>
                 <div className="flex items-end mb-1"><span className="text-[8px] text-slate-400 w-6">By:</span> <div className="border-b border-slate-300 flex-1"></div></div>
                 <div className="flex items-end"><span className="text-[8px] text-slate-400 w-6">Date:</span> <div className="border-b border-slate-300 flex-1"></div></div>
              </div>
              <div>
                 <p className="font-bold text-[9px] uppercase text-slate-800">{settings.contractorName}</p>
                 <p className="text-[8px] text-slate-500 leading-tight">{settings.contractorAddress1}</p>
                 <p className="text-[8px] text-slate-500 mb-3 leading-tight">{settings.contractorAddress2}</p>
                 <div className="flex items-end mb-1"><span className="text-[8px] text-slate-400 w-6">By:</span> <div className="border-b border-slate-300 flex-1"></div></div>
                 <div className="flex items-end"><span className="text-[8px] text-slate-400 w-6">Date:</span> <div className="border-b border-slate-300 flex-1"></div></div>
              </div>
              <div>
                 <p className="font-bold text-[9px] uppercase text-slate-800">{settings.ownerName}</p>
                 <p className="text-[8px] text-slate-500 leading-tight">{settings.ownerAddress1}</p>
                 <p className="text-[8px] text-slate-500 mb-3 leading-tight">{settings.ownerAddress2}</p>
                 <div className="flex items-end mb-1"><span className="text-[8px] text-slate-400 w-6">By:</span> <div className="border-b border-slate-300 flex-1"></div></div>
                 <div className="flex items-end"><span className="text-[8px] text-slate-400 w-6">Date:</span> <div className="border-b border-slate-300 flex-1"></div></div>
              </div>
           </div>
        </div>
      </div>
    </div>
  );
};

// --- COMPONENT: Log Print View (Landscape) ---
const LogPrintView = ({ mods, settings, logoUrl, projectName }) => {
  // Calculate totals
  const totalUsed = mods.reduce((acc, m) => m.status !== 'Rejected' ? acc + Number(m.amount) : acc, 0);
  const remaining = settings.originalContingency - totalUsed;

  // Calculate running balances for the table
  let running = settings.originalContingency;
  const rows = mods.map(m => {
      const isRejected = m.status === 'Rejected';
      if (!isRejected) running -= Number(m.amount);
      return { ...m, runningBalance: isRejected ? '-' : running };
  });

  return (
     <div id="log-print-area" className="bg-white p-4 text-xs font-serif text-slate-800" style={{ width: '10.5in', minHeight: '8in' }}>
        {/* Header */}
        <div className="flex justify-between items-center mb-6 border-b-2 border-blue-900 pb-4">
            <div className="flex items-center">
                {logoUrl && <img src={logoUrl} className="h-16 w-auto mr-6 object-contain" alt="Logo" />}
                <div>
                    <h1 className="text-xl font-bold uppercase text-blue-900 leading-none mb-1">Contingency Log</h1>
                    <h2 className="text-lg font-bold text-slate-700 leading-none">{projectName}</h2>
                </div>
            </div>
            <div className="text-right">
                <p className="font-bold text-slate-500">Date Printed: {new Date().toLocaleDateString()}</p>
            </div>
        </div>

        {/* Summary Box */}
        <div className="flex gap-8 mb-6 bg-slate-50 p-4 rounded border border-slate-200">
            <div>
                <p className="text-slate-500 uppercase text-[10px] font-bold">Original Contingency</p>
                <p className="text-lg font-mono font-bold text-slate-900">{formatCurrency(settings.originalContingency)}</p>
            </div>
            <div>
                <p className="text-slate-500 uppercase text-[10px] font-bold">Total Approved/Pending</p>
                <p className="text-lg font-mono font-bold text-orange-600">{formatCurrency(totalUsed)}</p>
            </div>
            <div>
                <p className="text-slate-500 uppercase text-[10px] font-bold">Remaining Balance</p>
                <p className="text-lg font-mono font-bold text-green-700">{formatCurrency(remaining)}</p>
            </div>
        </div>

        {/* Table */}
        <table className="w-full text-left border-collapse text-[11px]">
            <thead>
                <tr className="border-b-2 border-slate-800 bg-slate-100">
                    <th className="py-2 px-2 font-bold text-slate-700 w-12">No.</th>
                    <th className="py-2 px-2 font-bold text-slate-700 w-24">Date</th>
                    <th className="py-2 px-2 font-bold text-slate-700 w-48">Subcontractor</th>
                    <th className="py-2 px-2 font-bold text-slate-700">Description</th>
                    <th className="py-2 px-2 font-bold text-slate-700 w-32">Status</th>
                    <th className="py-2 px-2 font-bold text-slate-700 text-right w-32">Amount</th>
                    <th className="py-2 px-2 font-bold text-slate-700 text-right w-32">Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr className="border-b border-slate-200 bg-slate-50 italic text-slate-500">
                    <td colSpan="6" className="py-2 px-2 text-right font-medium">Starting Balance:</td>
                    <td className="py-2 px-2 text-right font-mono font-medium">{formatCurrency(settings.originalContingency)}</td>
                </tr>
                {rows.map((row) => (
                    <tr key={row.id} className={`border-b border-slate-100 ${row.status === 'Rejected' ? 'opacity-60 bg-red-50' : ''}`}>
                        <td className="py-2 px-2 font-medium">{row.modNumber}</td>
                        <td className="py-2 px-2">{row.date}</td>
                        <td className="py-2 px-2">{row.subcontractor}</td>
                        <td className="py-2 px-2">{row.description}</td>
                        <td className="py-2 px-2 font-semibold text-[10px] uppercase">
                            <span className={`px-2 py-0.5 rounded-full ${
                                row.status === 'Fully Executed' ? 'bg-green-100 text-green-800' :
                                row.status === 'Rejected' ? 'bg-red-100 text-red-800' : 
                                'bg-yellow-100 text-yellow-800'
                            }`}>
                                {row.status}
                            </span>
                        </td>
                        <td className="py-2 px-2 text-right font-mono">
                            {row.status === 'Rejected' ? <span className="line-through">{formatCurrency(row.amount)}</span> : <span className="text-red-600">({formatCurrency(row.amount)})</span>}
                        </td>
                        <td className="py-2 px-2 text-right font-mono font-bold text-slate-900">
                            {row.status === 'Rejected' ? '-' : formatCurrency(row.runningBalance)}
                        </td>
                    </tr>
                ))}
            </tbody>
            {/* Footer Row */}
            <tfoot>
                 <tr className="border-t-2 border-slate-800 bg-slate-100 font-bold">
                    <td colSpan="6" className="py-3 px-2 text-right text-slate-700 uppercase text-[10px] tracking-wide">Remaining Contractor Contingency Balance:</td>
                    <td className="py-3 px-2 text-right font-mono text-lg text-green-700">{formatCurrency(remaining)}</td>
                </tr>
            </tfoot>
        </table>
     </div>
  );
};

// --- COMPONENT: Login Screen ---
const LoginScreen = ({ onLogin, error, isLoading }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
          <Building className="h-12 w-12 text-blue-600 mr-3" />
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Rick Scott Construction</h1>
            <p className="text-sm text-slate-500">CMOD Builder v1.8</p>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-6">
          <div className="flex items-center justify-center mb-4">
            <Lock className="w-5 h-5 text-slate-400 mr-2" />
            <h2 className="text-lg font-semibold text-slate-700">Sign In</h2>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-300 rounded-md p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                placeholder="you@rickscottconstruction.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-slate-300 rounded-md p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-3 rounded-md font-bold text-white transition-colors ${
                isLoading
                  ? 'bg-slate-400 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700'
              }`}
            >
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p className="text-xs text-slate-400 text-center mt-6">
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
};

// --- MAIN APP COMPONENT ---
const App = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [newProjectTitle, setNewProjectTitle] = useState('');
  const [lastSaved, setLastSaved] = useState(null);
  const [user, setUser] = useState(null);
  const [syncStatus, setSyncStatus] = useState('disconnected'); // disconnected, syncing, synced, error
  const [loginError, setLoginError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [authLoading, setAuthLoading] = useState(true); // Loading state while checking auth
  
  // --- MULTI-PROJECT STATE INITIALIZATION ---
  const [activeProjectId, setActiveProjectId] = useState('autumn-park');
  const [projects, setProjects] = useState(hardcodedProjects);

  // State for preview and inputs
  const [previewMod, setPreviewMod] = useState(null);
  const [isLibraryLoaded, setIsLibraryLoaded] = useState(false);
  const [isPdfLibraryLoaded, setIsPdfLibraryLoaded] = useState(false);
  const [isPdfParserLoaded, setIsPdfParserLoaded] = useState(false);
  const [smartPasteText, setSmartPasteText] = useState('');
  const [logoUrl, setLogoUrl] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [newlyCreatedModIds, setNewlyCreatedModIds] = useState([]); // Track mods created this session
  const fileInputRef = useRef(null);
  const configInputRef = useRef(null);

  // Derived state
  const currentProject = projects[activeProjectId] || projects['autumn-park'];
  const currentMods = currentProject.mods;
  const currentSettings = currentProject.settings;

  const [formData, setFormData] = useState({
    project: currentProject.name,
    date: new Date().toISOString().split('T')[0],
    modNumber: '',
    subcontractor: '',
    amount: '',
    category: 'Contractor Contingency',
    description: '',
    notes: ''
  });

  // --- FIREBASE AUTH & SYNC ---
  useEffect(() => {
    if (!auth) return;

    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // --- LOGIN HANDLER ---
  const handleLogin = async (email, password) => {
    setIsLoggingIn(true);
    setLoginError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      console.error("Login error:", error);
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
        setLoginError('Invalid email or password.');
      } else if (error.code === 'auth/too-many-requests') {
        setLoginError('Too many failed attempts. Please try again later.');
      } else {
        setLoginError('Login failed. Please try again.');
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  // --- LOGOUT HANDLER ---
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // --- FIRESTORE REALTIME SYNC ---
  useEffect(() => {
    if (!user || !db) return;

    // Listener for PROJECTS data
    const projectsRef = doc(db, 'artifacts', appId, 'users', user.uid, 'rsc_data', 'projects');
    const unsubscribeProjects = onSnapshot(projectsRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.projects) {
           // Use smart merge to combine cloud data with local data
           // This prevents data loss when multiple tabs/sessions are open
           setProjects(prev => {
             const baseProjects = {...hardcodedProjects, ...prev};
             return mergeProjects(baseProjects, data.projects);
           });
           setSyncStatus('synced');
           setLastSaved(new Date().toLocaleTimeString());
        }
      }
      // Note: removed auto-save on first load to avoid dependency issues
    }, (error) => {
       console.error("Sync Error", error);
       setSyncStatus('error');
    });

    // Listener for LOGO data
    const settingsRef = doc(db, 'artifacts', appId, 'users', user.uid, 'rsc_data', 'settings');
    const unsubscribeSettings = onSnapshot(settingsRef, (docSnap) => {
       if (docSnap.exists()) {
           const data = docSnap.data();
           if (data.logoUrl) setLogoUrl(data.logoUrl);
       }
    });

    return () => {
      unsubscribeProjects();
      unsubscribeSettings();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // --- HELPER: SAVE TO CLOUD ---
  const saveToCloud = async (currentProjects, currentLogo) => {
    if (!user || !db) return;
    setSyncStatus('syncing');
    try {
       await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'rsc_data', 'projects'), { 
         projects: currentProjects,
         lastUpdated: new Date().toISOString()
       });
       
       if (currentLogo) {
           await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'rsc_data', 'settings'), {
             logoUrl: currentLogo
           });
       }
       setSyncStatus('synced');
       setLastSaved(new Date().toLocaleTimeString());
    } catch (e) {
      console.error("Save failed", e);
      setSyncStatus('error');
    }
  };

  // --- LOGIC: CREATE NEW PROJECT ---
  const handleCreateProjectClick = () => {
      setShowNewProjectModal(true);
  };

  const confirmCreateProject = (e) => {
      e.preventDefault();
      if (!newProjectTitle.trim()) return;
      
      const newId = newProjectTitle.toLowerCase().replace(/\s+/g, '-');
      if (projects[newId]) {
          alert("A project with this name already exists.");
          return;
      }

      const updatedProjects = {
          ...projects,
          [newId]: {
              id: newId,
              name: newProjectTitle,
              mods: [],
              settings: {
                  ...hardcodedProjects['autumn-park'].settings, 
                  originalContingency: 0,
                  ownerName: "Owner Name",
                  ownerAddress1: "Address Line 1",
                  ownerAddress2: "City, State, Zip",
                  architectName: "Architect Name",
                  architectAddress1: "Address Line 1",
                  architectAddress2: "City, State, Zip",
                  contractorName: "Rick Scott Construction, Inc.",
                  contractorAddress1: "4303 N. Pleasant View RD.",
                  contractorAddress2: "Ponca City, OK 74601"
              }
          }
      };

      setProjects(updatedProjects);
      saveToCloud(updatedProjects, logoUrl); // Sync to Cloud
      
      setActiveProjectId(newId);
      setActiveTab('settings'); 
      setShowNewProjectModal(false);
      setNewProjectTitle('');
  };

  // --- LOAD LIBRARIES (Unchanged) ---
  useEffect(() => {
    const script1 = document.createElement('script'); script1.src = "https://cdn.sheetjs.com/xlsx-latest/package/dist/xlsx.full.min.js"; script1.async = true; script1.onload = () => setIsLibraryLoaded(true); document.body.appendChild(script1);
    const script2 = document.createElement('script'); script2.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"; script2.async = true; script2.onload = () => setIsPdfLibraryLoaded(true); document.body.appendChild(script2);
    const script3 = document.createElement('script'); script3.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js"; script3.async = true; script3.onload = () => { if(window.pdfjsLib) { window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js'; setIsPdfParserLoaded(true); } }; document.body.appendChild(script3);

    return () => {
      if(document.body.contains(script1)) document.body.removeChild(script1);
      if(document.body.contains(script2)) document.body.removeChild(script2);
      if(document.body.contains(script3)) document.body.removeChild(script3);
    }
  }, []);

  // Update formData when switching projects
  useEffect(() => {
      if (!editingId) {
          setFormData(prev => ({
              ...prev,
              project: currentProject.name,
              modNumber: String(currentMods.length + 1)
          }));
      }
  }, [activeProjectId, currentProject.name, currentMods.length, editingId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSettingChange = (e) => {
    const { name, value } = e.target;
    const newSettings = { ...currentSettings, [name]: value };
    
    const updatedProjects = {
        ...projects,
        [activeProjectId]: {
            ...projects[activeProjectId],
            settings: newSettings
        }
    };
    setProjects(updatedProjects);
    saveToCloud(updatedProjects, logoUrl); // Sync to Cloud
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
              const canvas = document.createElement('canvas');
              const MAX_WIDTH = 600;
              const MAX_HEIGHT = 200;
              let width = img.width;
              let height = img.height;
              if (width > height) { if (width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; } } else { if (height > MAX_HEIGHT) { width *= MAX_HEIGHT / height; height = MAX_HEIGHT; } }
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0, width, height);
              const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
              setLogoUrl(dataUrl);
              saveToCloud(projects, dataUrl); // Sync Logo to Cloud
          };
          img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  // --- MANUAL EXPORT/IMPORT (BACKUP) ---
  const handleExportConfig = () => {
    const configData = { projects, logoUrl, timestamp: new Date().toISOString() };
    const blob = new Blob([JSON.stringify(configData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'RSC_All_Projects_Backup.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleImportConfig = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
        try {
            const data = JSON.parse(e.target.result);
            if (data.projects) {
                // Use smart merge to combine backup data with existing data
                // This prevents losing mods that exist in current data but not in backup
                const mergedProjects = mergeProjects(projects, data.projects);
                setProjects(mergedProjects);
                // Sync merged data to cloud
                saveToCloud(mergedProjects, data.logoUrl || logoUrl);
            }
            if (data.logoUrl) {
                setLogoUrl(data.logoUrl);
            }
            alert("Backup Merged & Synced to Cloud Successfully!\n\nAll modifications from both sources have been preserved.");
        } catch (err) {
            alert("Error loading file: " + err.message);
        }
    };
    reader.readAsText(file);
    if(configInputRef.current) configInputRef.current.value = "";
  };

  const handleStatusChange = (id, newStatus) => {
    const updatedMods = currentMods.map(mod => 
      mod.id === id ? { ...mod, status: newStatus } : mod
    );
    const updatedProjects = {
        ...projects,
        [activeProjectId]: {
            ...projects[activeProjectId],
            mods: updatedMods
        }
    };
    setProjects(updatedProjects);
    saveToCloud(updatedProjects, logoUrl);
  };

  const handleEditClick = (mod) => {
      setFormData({
          project: mod.project,
          date: mod.date,
          modNumber: mod.modNumber,
          subcontractor: mod.subcontractor,
          amount: mod.amount,
          category: mod.category,
          description: mod.description,
          notes: mod.notes || ''
      });
      setEditingId(mod.id);
      setActiveTab('create'); 
  };

  const clearForm = () => {
    setFormData({
        project: currentProject.name,
        date: new Date().toISOString().split('T')[0],
        modNumber: String(currentMods.length + 1),
        subcontractor: '',
        amount: '',
        category: 'Contractor Contingency',
        description: '',
        notes: ''
    });
    setSmartPasteText('');
    setEditingId(null);
  };

  // --- PDF PARSING / OCR LOGIC ---
  const processParsedText = (text) => {
    let extractedAmount = '';
    let extractedSub = '';
    let extractedDesc = '';
    let extractedDate = '';

    // Normalize text - replace multiple spaces with single space
    const normalizedText = text.replace(/\s+/g, ' ');
    const lines = text.split('\n').map(l => l.trim()).filter(l => l.length > 0);

    // Try to extract amount - look for dollar amounts or "total" lines
    const amountPatterns = [
      /total[:\s]*\$?\s*([0-9,]+\.?\d*)/i,
      /amount[:\s]*\$?\s*([0-9,]+\.?\d*)/i,
      /cost[:\s]*\$?\s*([0-9,]+\.?\d*)/i,
      /price[:\s]*\$?\s*([0-9,]+\.?\d*)/i,
      /\$\s*([0-9,]+\.\d{2})/,
      /([0-9,]+\.\d{2})\s*(dollars|USD)?/i
    ];

    for (const pattern of amountPatterns) {
      const match = normalizedText.match(pattern);
      if (match && match[1]) {
        const potentialAmount = match[1].replace(/,/g, '');
        // Make sure it's a reasonable amount (not a date or phone number)
        if (parseFloat(potentialAmount) > 0 && parseFloat(potentialAmount) < 10000000) {
          extractedAmount = potentialAmount;
          break;
        }
      }
    }

    // Try to extract date
    const datePatterns = [
      /date[:\s]*(\d{1,2}[/-]\d{1,2}[/-]\d{2,4})/i,
      /(\d{1,2}[/-]\d{1,2}[/-]\d{4})/,
      /(\d{4}[/-]\d{1,2}[/-]\d{1,2})/,
      /(january|february|march|april|may|june|july|august|september|october|november|december)\s+\d{1,2},?\s+\d{4}/i
    ];

    for (const pattern of datePatterns) {
      const match = normalizedText.match(pattern);
      if (match) {
        try {
          const parsedDate = new Date(match[1] || match[0]);
          if (!isNaN(parsedDate.getTime())) {
            extractedDate = parsedDate.toISOString().split('T')[0];
            break;
          }
        } catch (e) { /* continue */ }
      }
    }

    // Try to extract subcontractor/vendor
    const subPatterns = [
      /from[:\s]+([^\n]+)/i,
      /vendor[:\s]+([^\n]+)/i,
      /subcontractor[:\s]+([^\n]+)/i,
      /contractor[:\s]+([^\n]+)/i,
      /company[:\s]+([^\n]+)/i,
      /prepared\s+by[:\s]+([^\n]+)/i,
      /submitted\s+by[:\s]+([^\n]+)/i
    ];

    for (const pattern of subPatterns) {
      const match = normalizedText.match(pattern);
      if (match && match[1] && match[1].trim().length > 2) {
        extractedSub = match[1].trim().substring(0, 100); // Limit length
        break;
      }
    }

    // Try to extract description/subject
    const descPatterns = [
      /re[:\s]+([^\n]+)/i,
      /subject[:\s]+([^\n]+)/i,
      /regarding[:\s]+([^\n]+)/i,
      /description[:\s]+([^\n]+)/i,
      /scope[:\s]+([^\n]+)/i,
      /project[:\s]+([^\n]+)/i
    ];

    for (const pattern of descPatterns) {
      const match = normalizedText.match(pattern);
      if (match && match[1] && match[1].trim().length > 5) {
        extractedDesc = match[1].trim().substring(0, 200); // Limit length
        break;
      }
    }

    // If no description found, use first substantial line as description
    if (!extractedDesc && lines.length > 0) {
      for (const line of lines) {
        if (line.length > 20 && !line.match(/^(date|from|to|phone|fax|email)/i)) {
          extractedDesc = line.substring(0, 200);
          break;
        }
      }
    }

    setFormData(prev => ({
      ...prev,
      date: extractedDate || prev.date,
      amount: extractedAmount || prev.amount,
      subcontractor: extractedSub || prev.subcontractor,
      description: extractedDesc || prev.description,
      notes: text.substring(0, 2000) // Limit notes length
    }));
  };

  const handleSmartPaste = () => {
    if (smartPasteText) processParsedText(smartPasteText);
  };

  const handlePdfUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      alert("No file selected.");
      return;
    }
    if (!window.pdfjsLib) {
      alert("PDF library not loaded yet. Please wait a moment and try again.");
      return;
    }
    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const textParts = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        // Preserve line structure better by checking y-positions
        let lastY = null;
        let lineText = "";
        let pageText = "";
        textContent.items.forEach(item => {
          if (lastY !== null && Math.abs(item.transform[5] - lastY) > 5) {
            pageText += lineText.trim() + "\n";
            lineText = "";
          }
          lineText += item.str + " ";
          lastY = item.transform[5];
        });
        pageText += lineText.trim();
        textParts.push(pageText);
      }

      const fullText = textParts.join("\n\n");
      setSmartPasteText(fullText);
      // Don't auto-fill - let user preview and click Apply button
    } catch (err) {
      console.error("PDF Error:", err);
      alert("Error reading PDF: " + err.message);
    }
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let updatedProjects;

    if (editingId) {
        const updatedMod = {
            ...currentMods.find(m => m.id === editingId),
            ...formData,
            amount: parseFloat(formData.amount)
        };
        updatedProjects = {
            ...projects,
            [activeProjectId]: {
                ...projects[activeProjectId],
                mods: projects[activeProjectId].mods.map(m => m.id === editingId ? updatedMod : m)
            }
        };
        setPreviewMod(updatedMod);
        setEditingId(null);
    } else {
        const newModId = Date.now();
        const newMod = {
            id: newModId,
            ...formData,
            amount: parseFloat(formData.amount),
            status: 'Drafted'
        };
        updatedProjects = {
            ...projects,
            [activeProjectId]: {
                ...projects[activeProjectId],
                mods: [...projects[activeProjectId].mods, newMod]
            }
        };
        setPreviewMod(newMod);
        // Track this as a newly created mod (can be deleted)
        setNewlyCreatedModIds(prev => [...prev, newModId]);
    }

    setProjects(updatedProjects);
    saveToCloud(updatedProjects, logoUrl); // Sync to Cloud
    setActiveTab('preview');
  };

  const openPreview = (mod) => { setPreviewMod(mod); setActiveTab('preview'); };

  // Delete a newly created mod (only allowed for mods created this session)
  const handleDeleteMod = (modId) => {
    if (!newlyCreatedModIds.includes(modId)) {
      alert("This modification cannot be deleted. Use the edit button to make changes.");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this modification? This cannot be undone.")) {
      return;
    }

    const updatedProjects = {
      ...projects,
      [activeProjectId]: {
        ...projects[activeProjectId],
        mods: projects[activeProjectId].mods.filter(m => m.id !== modId)
      }
    };

    setProjects(updatedProjects);
    saveToCloud(updatedProjects, logoUrl);
    // Remove from newly created tracking
    setNewlyCreatedModIds(prev => prev.filter(id => id !== modId));
  };


  // ... (Export logic unchanged) ...
  const exportLogToExcel = () => {
    if (!window.XLSX) return;
    const XLSX = window.XLSX;
    const wb = XLSX.utils.book_new();
    const logData = [
      ["No", "STATUS", "ISSUED DATE", "REFERENCE", "DATE APPROVED", "DESCRIPTION", "COST"],
      ["", "", "", "Original Contractor Contingency Amount", "", "", currentSettings.originalContingency],
      ...currentMods.map(m => [ m.modNumber, m.status, m.date, m.subcontractor, m.status === 'Fully Executed' ? m.date : '', m.description, m.amount * -1 ])
    ];
    const wsLog = XLSX.utils.aoa_to_sheet(logData);
    wsLog['!cols'] = [{wch:5}, {wch:15}, {wch:12}, {wch:25}, {wch:15}, {wch:50}, {wch:12}];
    XLSX.utils.book_append_sheet(wb, wsLog, "Contingency Log");
    XLSX.writeFile(wb, `${currentProject.name.replace(/\s+/g, '_')}_Log.xlsx`);
  };

  const handleDownloadPDF = () => {
    if (!window.html2pdf) return;
    const element = document.getElementById('print-area');
    const opt = {
      margin: 0,
      filename: `CMOD_${previewMod.modNumber}_${previewMod.project.replace(/\s+/g, '_')}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        width: element.offsetWidth,
        height: element.offsetHeight
      },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    window.html2pdf().set(opt).from(element).save();
  };

  const handleDownloadLogPDF = () => {
    if (!window.html2pdf) return;
    const element = document.getElementById('log-print-area');
    const opt = {
      margin: [0.25, 0.25, 0.5, 0.25],
      filename: `${currentProject.name.replace(/\s+/g, '_')}_Log.pdf`,
      image: { type: 'jpeg', quality: 1.0 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
      pagebreak: { mode: ['css', 'legacy'] }
    };
    window.html2pdf().set(opt).from(element).toPdf().get('pdf').then(function(pdf) {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.25, { align: 'center' });
      }
    }).save();
  };

  let previewFinancials = { previousUsage: 0, currentBalance: 0 };
  let previewNewBalance = 0;
  if (activeTab === 'preview' && previewMod) {
      previewFinancials = calculateFinancials(currentMods, currentSettings.originalContingency, previewMod.id);
      previewNewBalance = previewFinancials.currentBalance - previewMod.amount;
  }

  // Show loading screen while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <Building className="h-16 w-16 text-blue-500 mx-auto mb-4 animate-pulse" />
          <p className="text-slate-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!user) {
    return <LoginScreen onLogin={handleLogin} error={loginError} isLoading={isLoggingIn} />;
  }

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 font-sans print:bg-white relative">
      {/* ... (Modals & Nav) ... */}
      {showNewProjectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md border-t-4 border-blue-600">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold text-slate-800">Create New Project</h3>
                    <button onClick={() => setShowNewProjectModal(false)} className="text-slate-400 hover:text-slate-600"><X className="w-5 h-5" /></button>
                </div>
                <form onSubmit={confirmCreateProject}>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Project Name</label>
                    <input type="text" value={newProjectTitle} onChange={(e) => setNewProjectTitle(e.target.value)} placeholder="e.g. Country Oaks Renovation" className="w-full border border-slate-300 rounded p-2 mb-4 focus:ring-2 focus:ring-blue-500 focus:outline-none" autoFocus />
                    <div className="flex justify-end gap-2">
                        <button type="button" onClick={() => setShowNewProjectModal(false)} className="px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded">Cancel</button>
                        <button type="submit" className="px-4 py-2 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded shadow">Create Project</button>
                    </div>
                </form>
            </div>
        </div>
      )}

      <nav className="bg-slate-900 text-white shadow-lg sticky top-0 z-50 print:hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-6">
              <div className="flex items-center">
                  <Building className="h-8 w-8 text-blue-500 mr-3" />
                  <div><span className="font-bold text-xl tracking-tight hidden md:block">Rick Scott Construction</span><span className="block text-xs text-slate-400 font-medium tracking-wider">CMOD BUILDER v1.8 (Smart Sync)</span></div>
              </div>
              <div className="flex bg-slate-800 rounded p-1 space-x-1 overflow-x-auto max-w-[300px] scrollbar-hide">
                  {Object.values(projects).map(p => (
                      <button key={p.id} onClick={() => { setActiveProjectId(p.id); setEditingId(null); clearForm(); }} className={`px-3 py-1 text-xs font-bold rounded transition-colors whitespace-nowrap ${activeProjectId === p.id ? 'bg-blue-600 text-white' : 'text-slate-400 hover:text-white'}`}>{p.name}</button>
                  ))}
                  <button type="button" onClick={handleCreateProjectClick} className="px-2 py-1 text-xs font-bold rounded bg-slate-700 text-slate-300 hover:text-white hover:bg-slate-600 flex items-center" title="Create New Project"><Plus className="w-3 h-3" /></button>
              </div>
            </div>
            <div className="flex space-x-4 items-center">
              <button onClick={() => { setActiveTab('dashboard'); setEditingId(null); clearForm(); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'dashboard' ? 'bg-slate-700 text-white' : 'text-slate-300 hover:bg-slate-700'}`}><LayoutDashboard className="inline-block w-4 h-4 mr-2" />Log</button>
              <button onClick={() => { setActiveTab('create'); setEditingId(null); clearForm(); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'create' ? 'bg-blue-800 text-white' : 'text-slate-300 hover:bg-slate-700'}`}><Plus className="inline-block w-4 h-4 mr-2" />New Mod</button>
              <button onClick={() => { setActiveTab('settings'); setEditingId(null); clearForm(); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'settings' ? 'bg-slate-700 text-white' : 'text-slate-300 hover:bg-slate-700'}`}><Settings className="inline-block w-4 h-4 mr-2" />Settings</button>
              <button onClick={() => { setActiveTab('transcripts'); setEditingId(null); clearForm(); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'transcripts' ? 'bg-indigo-700 text-white' : 'text-slate-300 hover:bg-slate-700'}`}><FileText className="inline-block w-4 h-4 mr-2" />Transcripts</button>
              <div className="border-l border-slate-700 h-6 mx-2"></div>
              <button onClick={handleLogout} className="px-3 py-2 rounded-md text-sm font-medium text-slate-400 hover:text-white hover:bg-red-600 transition-colors" title={`Sign out (${user?.email})`}><LogOut className="inline-block w-4 h-4" /></button>
            </div>
          </div>
        </div>
      </nav>

      {/* SUB-HEADER */}
      <div className="bg-white border-b border-slate-200 py-2 px-8 flex justify-between items-center print:hidden">
          <div className="flex items-center text-sm"><Layers className="w-4 h-4 text-slate-400 mr-2" /><span className="text-slate-500 mr-2">Active Project:</span><span className="font-bold text-blue-900">{currentProject.name}</span></div>
          <div className="flex items-center text-xs text-slate-400 gap-4">
              <span className="text-slate-500">{user?.email}</span>
              <span className="text-slate-300">|</span>
              <span>{currentMods.length} modifications tracked</span>
              {/* CLOUD STATUS INDICATOR */}
              {syncStatus === 'synced' && <span className="flex items-center text-green-600 font-medium"><Cloud className="w-3 h-3 mr-1"/> Saved to Cloud: {lastSaved}</span>}
              {syncStatus === 'syncing' && <span className="flex items-center text-blue-500 font-medium"><RotateCcw className="w-3 h-3 mr-1 animate-spin"/> Syncing...</span>}
              {syncStatus === 'error' && <span className="flex items-center text-red-600 font-medium"><CloudOff className="w-3 h-3 mr-1"/> Save Failed</span>}
          </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 print:p-0 print:max-w-none">
        {/* ... (Existing Views: Dashboard, Settings, Create, Preview - Unchanged logic, just using new Cloud handlers) ... */}
        {/* DASHBOARD */}
        {activeTab === 'dashboard' && (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-bold text-slate-800">Modification Log</h2>
              <div className="flex space-x-2">
                  <button onClick={handleDownloadLogPDF} disabled={!isLibraryLoaded} className={`text-white px-4 py-2 rounded shadow flex items-center transition-all ${isLibraryLoaded ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400'}`}>
                    <Printer className="w-5 h-5 mr-2" />{isLibraryLoaded ? 'Print Log (PDF)' : 'Loading...'}
                  </button>
                  <button onClick={exportLogToExcel} disabled={!isLibraryLoaded} className={`text-white px-4 py-2 rounded shadow flex items-center transition-all ${isLibraryLoaded ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-400'}`}>
                    <FileSpreadsheet className="w-5 h-5 mr-2" />{isLibraryLoaded ? 'Download Excel' : 'Loading...'}
                  </button>
              </div>
            </div>
            {/* Hidden Log Print Area for PDF generation */}
            <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
              <LogPrintView
                mods={currentMods}
                settings={currentSettings}
                logoUrl={logoUrl}
                projectName={currentProject.name}
              />
            </div>

            {currentMods.length === 0 ? (
                <div className="bg-white rounded-lg shadow p-12 text-center border-2 border-dashed border-slate-200">
                    <FolderPlus className="w-12 h-12 text-slate-300 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-slate-600">No Modifications Yet</h3>
                    <p className="text-slate-400 mb-6">Start tracking changes for {currentProject.name}.</p>
                    <button onClick={() => setActiveTab('create')} className="bg-blue-600 text-white px-6 py-2 rounded font-bold hover:bg-blue-700">Create First Mod</button>
                </div>
            ) : (
                <div className="bg-white shadow rounded-lg overflow-hidden border border-slate-200">
                <table className="min-w-full divide-y divide-slate-200">
                    <thead className="bg-slate-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase">#</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase">Date</th>
                        <th className="px-6 py-3 text-left text-xs font-bold text-slate-500 uppercase">Description</th>
                        <th className="px-6 py-3 text-right text-xs font-bold text-slate-500 uppercase">Amount</th>
                        <th className="px-6 py-3 text-center text-xs font-bold text-slate-500 uppercase">Status</th>
                        <th className="px-6 py-3 text-right">Actions</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-slate-200">
                    {currentMods.map((mod) => (
                        <tr key={mod.id} className="hover:bg-slate-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-slate-900 cursor-pointer" onClick={() => openPreview(mod)}>{mod.modNumber}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500 cursor-pointer" onClick={() => openPreview(mod)}>{mod.date}</td>
                        <td className="px-6 py-4 text-sm text-slate-600 max-w-xs truncate cursor-pointer" onClick={() => openPreview(mod)}>{mod.description}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-right text-slate-900 cursor-pointer" onClick={() => openPreview(mod)}>
                            {mod.status === 'Rejected' ? <span className="line-through text-slate-400">{formatCurrency(mod.amount)}</span> : formatCurrency(mod.amount)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                            <div className="relative inline-block w-40">
                            <select value={mod.status} onChange={(e) => handleStatusChange(mod.id, e.target.value)} className={`block w-full pl-3 pr-8 py-1 text-xs font-semibold rounded-full appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer border-none shadow-sm ${mod.status === 'Fully Executed' ? 'bg-green-100 text-green-800' : mod.status === 'Rejected' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                <option value="Drafted">Drafted</option>
                                <option value="Sent to Architect">Sent to Architect</option>
                                <option value="Sent to Owner">Sent to Owner</option>
                                <option value="Fully Executed">Fully Executed</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"><svg className="fill-current h-4 w-4 opacity-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg></div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm">
                            <div className="flex justify-end space-x-2">
                                <button onClick={() => handleEditClick(mod)} className="text-blue-500 hover:text-blue-700" title="Edit Mod"><Pencil className="w-4 h-4" /></button>
                                {newlyCreatedModIds.includes(mod.id) && (
                                  <button onClick={() => handleDeleteMod(mod.id)} className="text-red-500 hover:text-red-700" title="Delete Mod"><Trash2 className="w-4 h-4" /></button>
                                )}
                                <button onClick={() => openPreview(mod)} className="text-slate-400 hover:text-slate-600" title="View PDF"><ChevronRight className="w-4 h-4" /></button>
                            </div>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            )}
          </div>
        )}

        {/* SETTINGS */}
        {activeTab === 'settings' && (
           <div className="max-w-4xl mx-auto space-y-6">
              <h2 className="text-xl font-bold text-slate-800">Project Settings: <span className="text-blue-600">{currentProject.name}</span></h2>
              
              <div className="bg-blue-50 p-6 rounded shadow border border-blue-200">
                  <h3 className="font-bold text-blue-900 mb-2 flex items-center"><FileJson className="w-5 h-5 mr-2" />Backup / Restore Data</h3>
                  <div className="flex gap-4 mt-4">
                      <button onClick={handleExportConfig} className="bg-blue-700 text-white px-4 py-2 rounded text-sm font-bold hover:bg-blue-800 flex items-center shadow"><Download className="w-4 h-4 mr-2" /> Backup Data to File</button>
                      <div className="relative">
                          <input type="file" accept=".json" ref={configInputRef} onChange={handleImportConfig} className="hidden" id="config-upload" />
                          <label htmlFor="config-upload" className="bg-white text-blue-700 border border-blue-300 px-4 py-2 rounded text-sm font-bold hover:bg-blue-50 flex items-center shadow cursor-pointer"><Upload className="w-4 h-4 mr-2" /> Restore Data from File</label>
                      </div>
                  </div>
              </div>

              <div className="bg-white p-6 rounded shadow border border-slate-200">
                  <h3 className="font-bold text-slate-800 mb-4">Company Logo (Global)</h3>
                  <div className="flex items-center space-x-6">
                     <div className="w-32 h-32 bg-slate-100 border-2 border-dashed border-slate-300 flex items-center justify-center rounded overflow-hidden">
                        {logoUrl ? <img src={logoUrl} className="w-full h-full object-contain" alt="Preview"/> : <span className="text-xs text-slate-400 text-center">No Logo</span>}
                     </div>
                     <div className="flex-1">
                        <label className="block text-sm font-medium text-slate-700 mb-2">Upload Image File (PNG/JPG)</label>
                        <input type="file" accept="image/*" onChange={handleLogoUpload} className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                     </div>
                  </div>
              </div>

              {/* PROJECT SPECIFIC INFO (SPLIT ADDRESSES) */}
              <div className="bg-white p-6 rounded shadow border border-slate-200 space-y-6">
                  <h3 className="font-bold text-slate-800 mb-2">Project Details & Parties</h3>
                  
                  {/* Financials */}
                  <div>
                      <label className="text-xs font-bold text-blue-600 uppercase tracking-wide">Financials</label>
                      <div className="mt-2">
                          <label className="text-xs font-bold text-slate-500">Original Contingency Amount ($)</label>
                          <input name="originalContingency" type="number" value={currentSettings.originalContingency} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm font-mono"/>
                      </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Owner Section */}
                      <div className="space-y-2">
                          <label className="text-xs font-bold text-blue-600 uppercase tracking-wide border-b block pb-1">Owner</label>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Name</label>
                              <input name="ownerName" value={currentSettings.ownerName} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm" placeholder="e.g. Osage Casino"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 1</label>
                              <input name="ownerAddress1" value={currentSettings.ownerAddress1} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm" placeholder="Street Address"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 2</label>
                              <input name="ownerAddress2" value={currentSettings.ownerAddress2} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm" placeholder="City, State, Zip"/>
                          </div>
                      </div>

                      {/* Architect Section */}
                      <div className="space-y-2">
                          <label className="text-xs font-bold text-blue-600 uppercase tracking-wide border-b block pb-1">Architect</label>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Name</label>
                              <input name="architectName" value={currentSettings.architectName} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 1</label>
                              <input name="architectAddress1" value={currentSettings.architectAddress1} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 2</label>
                              <input name="architectAddress2" value={currentSettings.architectAddress2} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                      </div>

                      {/* Contractor Section */}
                      <div className="space-y-2">
                          <label className="text-xs font-bold text-blue-600 uppercase tracking-wide border-b block pb-1">Construction Manager</label>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Name</label>
                              <input name="contractorName" value={currentSettings.contractorName} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 1</label>
                              <input name="contractorAddress1" value={currentSettings.contractorAddress1} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                          <div>
                              <label className="text-xs font-bold text-slate-500">Address Line 2</label>
                              <input name="contractorAddress2" value={currentSettings.contractorAddress2} onChange={handleSettingChange} className="w-full border p-2 rounded text-sm"/>
                          </div>
                      </div>
                  </div>
              </div>
           </div>
        )}

        {/* CREATE / EDIT */}
        {activeTab === 'create' && (
          <div className="max-w-4xl mx-auto">
             <div className="flex items-center justify-between mb-6">
                <button onClick={() => setActiveTab('dashboard')} className="text-sm text-slate-500 hover:text-slate-800 flex items-center"><ChevronRight className="w-4 h-4 rotate-180 mr-1" /> Back to Dashboard</button>
                <h2 className="text-xl font-bold text-slate-800">
                    {editingId ? <span className="text-orange-600">Editing Mod #{formData.modNumber}</span> : <span>New Contingency Mod</span>}
                    <span className="text-blue-600 ml-2">({currentProject.name})</span>
                </h2>
             </div>
            <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-6 mb-8">
              <div className="flex justify-between items-center mb-2">
                <h3 className="text-indigo-900 font-bold flex items-center"><ClipboardPaste className="w-5 h-5 mr-2" />Smart Paste (Beta)</h3>
                <div className="relative">
                    <input type="file" accept=".pdf" ref={fileInputRef} onChange={handlePdfUpload} className="hidden" id="pdf-upload" />
                    <label htmlFor="pdf-upload" className={`flex items-center px-3 py-1.5 text-xs font-bold rounded cursor-pointer transition-colors ${isPdfParserLoaded ? 'bg-indigo-200 text-indigo-800 hover:bg-indigo-300' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}>
                        <UploadCloud className="w-4 h-4 mr-1" />{isPdfParserLoaded ? "Upload PDF Quote" : "Loading PDF Engine..."}
                    </label>
                </div>
              </div>
              <p className="text-sm text-indigo-700 mb-4">Paste the text from an email or quote here, OR upload a PDF. Preview the extracted text below, then click Apply to fill in the form fields.</p>
              <div className="flex gap-2">
                <textarea className="flex-1 p-3 text-sm border border-indigo-200 rounded-md focus:ring-2 focus:ring-indigo-500" rows={8} placeholder="Paste here... e.g. 'Quote from Beene Plumbing...'" value={smartPasteText} onChange={(e) => setSmartPasteText(e.target.value)} />
                <button onClick={handleSmartPaste} className="bg-indigo-600 text-white px-4 py-2 rounded-md font-medium hover:bg-indigo-700 transition-colors flex items-center self-end">Apply <ArrowRight className="w-4 h-4 ml-1" /></button>
              </div>
            </div>
            <div className="bg-white shadow-lg rounded-lg border border-slate-200">
              <div className="flex justify-end p-4 border-b border-slate-100">
                <button type="button" onClick={clearForm} className="text-sm text-slate-500 hover:text-red-600 flex items-center">{editingId ? <><X className="w-3 h-3 mr-1" /> Cancel Edit</> : <><RotateCcw className="w-3 h-3 mr-1" /> Reset Form</>}</button>
              </div>
              <form onSubmit={handleSubmit} className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div><label className="block text-sm font-medium text-slate-700 mb-1">Date</label><input type="date" name="date" required value={formData.date} onChange={handleInputChange} className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" /></div>
                  <div><label className="block text-sm font-medium text-slate-700 mb-1">Amount ($)</label><input type="number" name="amount" step="0.01" required value={formData.amount} onChange={handleInputChange} className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" placeholder="0.00" /></div>
                </div>
                <div><label className="block text-sm font-medium text-slate-700 mb-1">Subcontractor / Reference</label><input type="text" name="subcontractor" required value={formData.subcontractor} onChange={handleInputChange} className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" /></div>
                <div><label className="block text-sm font-medium text-slate-700 mb-1">Description (Title)</label><input type="text" name="description" required value={formData.description} onChange={handleInputChange} className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" placeholder="Brief title of the change..." /></div>
                <div><label className="block text-sm font-medium text-slate-700 mb-1">Detailed Scope / Notes</label><textarea name="notes" rows={6} value={formData.notes} onChange={handleInputChange} className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" placeholder="Enter the full 'Authorized use' text here..." /></div>
                <div className="pt-4 flex justify-end space-x-4 border-t border-slate-100">
                  <button type="submit" className={`px-6 py-2 text-sm font-bold text-white rounded flex items-center shadow-lg transform active:scale-95 transition-all ${editingId ? 'bg-orange-600 hover:bg-orange-700' : 'bg-blue-800 hover:bg-blue-900'}`}><Save className="w-4 h-4 mr-2" /> {editingId ? "Save Changes" : "Create Mod"}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {activeTab === 'transcripts' && (
          <TranscriptPanel />
        )}

        {activeTab === 'preview' && previewMod && (
          <div>
            <div className="max-w-4xl mx-auto flex justify-between items-center mb-4 print:hidden">
              <button onClick={() => setActiveTab('dashboard')} className="text-sm text-slate-500 hover:text-slate-800 flex items-center"><ChevronRight className="w-4 h-4 rotate-180 mr-1" /> Back to Log</button>
              <div className="space-x-4">
                 <button onClick={handleDownloadPDF} disabled={!isPdfLibraryLoaded} className={`px-4 py-2 rounded shadow flex items-center transition-all ${isPdfLibraryLoaded ? 'bg-blue-800 text-white hover:bg-blue-700' : 'bg-gray-400 text-white cursor-not-allowed'}`}>
                   <Download className="w-4 h-4 mr-2" /> {isPdfLibraryLoaded ? 'Download PDF' : 'Loading Engine...'}
                 </button>
              </div>
            </div>
            
            <DocumentPreview 
              mod={previewMod} 
              settings={currentSettings}
              logoUrl={logoUrl}
              previousUsage={previewFinancials.previousUsage}
              currentBalance={previewFinancials.currentBalance}
              newBalance={previewNewBalance}
            />
          </div>
        )}
      </main>
    </div>
  );
};

export default App;